import { useEffect, useRef } from 'react';

export function usePreviousVal<ValueT>(value: ValueT): ValueT | undefined {
  const ref = useRef<ValueT | undefined>();
  useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
}
